import React from 'react';
import { observer } from 'mobx-react';
import { TextField, InputAdornment } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import classnames from 'classnames';

import { Typography } from '../../../../components/Wrappers/Wrappers';
import LoadingAnimation from '../../../../components/LoadingAnimation';
import IntegrationCard from './IntegrationCard';
import useConnectIntegrations from './useConnectIntegrations';
import { useStyles } from './integrationsSection.styles';

function ConnectIntegrationsSection () {
    const classes = useStyles();
    const {
        loading,
        query,
        setQuery,
        category,
        setCategory,
        categories,
        filtered,
    } = useConnectIntegrations();

    return (
        <div>
            <div className={classes.headerRow}>
                <div>
                    <Typography variant="h5" weight="bold" style={{ fontSize: 22 }}>Browse integrations, ready to go</Typography>
                    <Typography variant="body2" className={classes.lede}>
                        Need a custom integration? You can place a request via the ECAL Support agent.
                    </Typography>
                </div>
                <TextField
                    variant="outlined"
                    size="small"
                    placeholder="Search integrations…"
                    value={query}
                    onChange={(event) => setQuery(event.target.value)}
                    className={classes.search}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon fontSize="small" />
                            </InputAdornment>
                        ),
                    }}
                    inputProps={{ 'aria-label': 'Search integrations' }}
                />
            </div>

            {loading ? (
                <div className={classes.loaderBox}>
                    <LoadingAnimation />
                </div>
            ) : (
                <React.Fragment>
                    <div className={classes.pillRow}>
                        {categories.map((cat) => (
                            <button
                                key={cat}
                                type="button"
                                className={classnames(classes.chip, { [classes.chipActive]: category === cat })}
                                onClick={() => setCategory(cat)}
                            >
                                {cat}
                            </button>
                        ))}
                    </div>

                    {filtered.length === 0 ? (
                        <div className={classes.empty}>No integrations match that filter</div>
                    ) : (
                        <div className={classes.grid}>
                            {filtered.map((integration) => (
                                <IntegrationCard
                                    key={integration.id}
                                    integration={integration}
                                />
                            ))}
                        </div>
                    )}
                </React.Fragment>
            )}
        </div>
    );
}

const ObservedConnectIntegrationsSection = observer(ConnectIntegrationsSection);
export default ObservedConnectIntegrationsSection;
